var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn-toggle', {
    attrs: {
      "dense": "",
      "tile": ""
    },
    on: {
      "change": _vm.push
    },
    model: {
      value: _vm.group,
      callback: function ($$v) {
        _vm.group = $$v;
      },
      expression: "group"
    }
  }, [_vm._l(_vm.groups, function (_ref) {
    var text = _ref.text,
      value = _ref.value;
    return [_c('v-btn', _vm._b({
      key: value
    }, 'v-btn', {
      value
    }, false), [_vm._v(_vm._s(text))])];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }